import { render } from "./reportHistoryIndex.vue?vue&type=template&id=12c08b5b"
import script from "./reportHistoryIndex.vue?vue&type=script&lang=js"
export * from "./reportHistoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__